import styled from 'styled-components';
import { Quality } from 'dragonmouse-shared/interfaces';
import { CurrencyLevel } from 'economy';
import { zIndex } from 'tokens';

export const QualityToggleWrapper = styled.div`
	position: relative;
	display: inline-flex;
`;

export const TooltipMessage = styled.div`
	position: absolute;
	left: 16px;
	bottom: calc(100% + 8px);
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 12px 16px;
	background: ${({ theme }) => theme.gray[900]};
	color: ${({ theme }) => theme.gray[100]};
	border-radius: 2px;
	box-shadow: 0 12px 18px rgba(0, 0, 0, 0.25);
	width: 260px;
	z-index: ${zIndex.island};
`;

export const TooltipMessageDescription = styled.span`
	font-size: 13px;
	line-height: 1.4;
`;

export const TooltipMessageDismissButton = styled.button`
	align-self: flex-start;
	margin-top: 4px;
	padding: 0;
	border: none;
	background: none;
	color: ${({ theme }) => theme.white};
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	text-decoration: underline;
	line-height: 1.2;
	transition: color 0.2s ease;

	&:hover {
		color: ${({ theme }) => theme.gray[400]};
	}
`;

export const TooltipMessageCaret = styled.span`
	position: absolute;
	width: 12px;
	height: 12px;
	background: ${({ theme }) => theme.gray[900]};
	transform: rotate(45deg);
	bottom: -6px;
	left: 15px;
	box-shadow: 0 12px 18px rgba(0, 0, 0, 0.25);
`;

interface QualityToggleContainerProps {
	isMobile?: boolean;
}

export const QualityToggleContainer = styled.div<QualityToggleContainerProps>`
	display: flex;
	align-items: center;
	gap: ${({ isMobile }) => (isMobile ? '6px' : '0px')};
	background-color: ${({ theme }) => theme.gray[200]};
	border-radius: 42px;
	padding: ${({ isMobile }) => (isMobile ? '4px' : '2px')};
	transform: ${({ isMobile }) => (isMobile ? 'scale(1.2)' : 'scale(1)')};
`;

interface QualityCircleWrapperProps {
	isActive: boolean;
	walletLevel?: CurrencyLevel;
}

export const QualityCircleWrapper = styled.div<QualityCircleWrapperProps>`
	position: relative;
	padding: 2px 3px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
	border-radius: 5px;
	&:hover {
		background-color: ${({ isActive, theme, walletLevel }) =>
			isActive || walletLevel === 'EMPTY' ? 'transparent' : theme.gray[400]};
	}
`;

interface QualityCircleProps {
	quality: Quality;
	isActive: boolean;
	walletLevel?: CurrencyLevel;
}

export const QualityCircle = styled.div<QualityCircleProps>`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	border: ${({ isActive, theme }) => {
		return isActive ? `2.5px solid ${theme.gray[800]}` : `2.5px solid ${theme.gray[200]}`;
	}};
	background-color: ${({ quality, isActive }) => {
		if (quality === Quality.GOLD) {
			return isActive ? '#FFD700' : '#FFEAA7';
		} else {
			return isActive ? '#C0C0C0' : '#E0E0E0';
		}
	}};
	transition: all 0.2s ease;
	position: relative;
	opacity: ${({ walletLevel }) => (walletLevel === 'EMPTY' ? 0.4 : 1)};
	&:hover {
		border: ${({ isActive, theme }) =>
			isActive ? `2.5px solid ${theme.gray[800]}` : `2.5px solid ${theme.gray[400]}`};
	}
`;

export const ErrorIconOverlay = styled.div`
	position: absolute;
	top: -1px;
	right: -1px;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
`;

interface MobileToastProps {
	isVisible: boolean;
}

export const MobileToast = styled.div<MobileToastProps>`
	position: fixed;
	top: calc(env(safe-area-inset-top, 0px) + 12px);
	left: 50%;
	transform: translateX(-50%);
	max-width: 90vw;
	background-color: ${({ theme }) => theme.gray[1000]};
	color: ${({ theme }) => theme.gray[0]};
	padding: 12px 18px;
	border-radius: 999px;
	box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	transition: opacity 0.2s ease;
	font-family: Inter;
	font-size: 16px;
	font-weight: 500;
	line-height: 1.4;
	text-align: center;
	pointer-events: none;
	z-index: 999;
`;
